import React from "react";
import successTick1x from "../assets/images/light_theme1x.png";
import successTick2x from "../assets/images/light_theme2x.png";
import successTick3x from "../assets/images/light_theme3x.png";
import Image from "@vfuk/core-image";

type SuccessTickProps = {
  altText: string;
};
export const SuccessTick = ({ altText }: SuccessTickProps) => {
  return (
    <Image
      alt={altText}
      sm={{
        src: successTick2x,
        srcSet: {
          x1: successTick1x,
          x2: successTick2x,
          x3: successTick3x,
        },
      }}
    />
  );
};
